export default __webpack_public_path__ + "static/media/airplane.a5226ef8.png";